import { render, staticRenderFns } from "./iconChevronRight.vue?vue&type=template&id=4aa7b622"
import script from "./iconChevronRight.vue?vue&type=script&lang=js"
export * from "./iconChevronRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports